<div class="filter-section">
  <div class="filter-header" (click)="toggleFilters($event)" [attr.aria-expanded]="showFilters" role="button" tabindex="0" (keydown.enter)="toggleFilters($event)" (keydown.space)="toggleFilters($event); $event.preventDefault()">
    <div class="filter-header-left">
      <img src="/filters/filter.svg" alt="Filter" class="filter-icon" width="20" height="20" />
      <h3 class="filter-title">Filters</h3>
      <span class="filter-badge" *ngIf="activeFilterCount > 0">{{ activeFilterCount }}</span>
    </div>
    <div class="filter-header-right">
      <button class="clear-all-btn" (click)="onClearFilters($event); $event.stopPropagation()" *ngIf="activeFilterCount > 0">
        Clear All
      </button>
      <div class="filter-toggle-btn" aria-hidden="true">
        <svg class="toggle-icon" [class.rotated]="!showFilters" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>

  <div class="filter-content" [class.collapsed]="!showFilters" (click)="$event.stopPropagation()">
    <div class="filter-controls">
      <div class="filter-group" *ngFor="let field of fields" [class.filter-group--dropdown-open]="openDropdownFieldKey === field.key">
        <label class="filter-label">{{ field.label }}</label>
        
        <!-- Text Input -->
        <div *ngIf="field.type === 'text'" class="relative">
          <input 
            type="text" 
            [(ngModel)]="filterValues[field.key]"
            (input)="onFilterChange(field.key, filterValues[field.key])"
            class="filter-input"
            [placeholder]="field.placeholder || ''"
          />
          <svg
            *ngIf="filterValues[field.key] && filterValues[field.key].trim() !== ''"
            class="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            (click)="removeFilter(field.key)"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </div>
        
        <!-- Select Dropdown -->
        <div *ngIf="field.type === 'select'" class="relative">
          <select 
            [(ngModel)]="filterValues[field.key]"
            (change)="onFilterChange(field.key, filterValues[field.key])"
            class="filter-select"
            [class.placeholder-selected]="!filterValues[field.key] || filterValues[field.key] === ''"
          >
            <option value="">{{ field.placeholder || 'Choose ' + field.label }}</option>
            <ng-container *ngFor="let option of field.options">
              <!-- If options are objects with {label,value}, use value for selection and label for display -->
              <option *ngIf="option && typeof option === 'object' && 'label' in option && 'value' in option"
                [ngValue]="option.value"
              >
                {{ option.label }}
              </option>
              <!-- Otherwise treat as primitive -->
              <option *ngIf="!option || typeof option !== 'object' || !('label' in option) || !('value' in option)"
                [ngValue]="option"
              >
                {{ option }}
              </option>
            </ng-container>
          </select>
          <svg
            *ngIf="filterValues[field.key] && filterValues[field.key] !== '' && filterValues[field.key] !== 'All Types' && filterValues[field.key] !== 'All Activities' && filterValues[field.key] !== 'All Time'"
            class="absolute right-10 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            (click)="removeFilter(field.key)"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </div>
        
        <!-- Multiselect -->
        <app-multiselect
          *ngIf="field.type === 'multiselect'"
          [(ngModel)]="filterValues[field.key]"
          [options]="field.options || []"
          [optionLabel]="getOptionLabel(field)"
          [placeholder]="field.placeholder || 'Choose ' + field.label"
          display="chip"
          [maxSelected]="field.maxSelected || 0"
          (onChange)="onFilterChange(field.key, $event)"
          (onOpen)="onMultiselectOpen(field)"
          (onClose)="onMultiselectClose(field)"
          [showClear]="true"
          styleClass="filter-multiselect"
        ></app-multiselect>
        
        <!-- Date Range Picker -->
        <app-date-range-picker
          *ngIf="field.type === 'dateRange'"
          [(ngModel)]="filterValues[field.key]"
          (onDateRangeChange)="onDateRangeChange(field.key, $event)"
          (onOpen)="onDateRangePickerOpen(field)"
          (onClose)="onDateRangePickerClose(field)"
          [placeholder]="field.placeholder || 'Choose Date Range'"
          styleClass="filter-select"
        ></app-date-range-picker>
      </div>
    </div>
  </div>
</div>
